import { Button } from "reactstrap";
import { useState, useRef, useEffect, useMemo, useCallback } from "react";
import {
    CircularProgressbarWithChildren,
    buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faStop, faPause } from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";
import RotatePhonePopup from "../RotatePhonePopup";
import Lottie from 'lottie-react';
import axios from "axios";
import CompletePopup from "./completepopup";
import { useSnackbar } from "../context/SnackbarContext";

import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase-config';

// img
import microphone from "../../img/microphone.png"

import lottieAnimation1 from "../../lottie/confession3.json"
import lottieAnimation2 from "../../lottie/confession3.json"
import lottieAnimation3 from "../../lottie/confession3.json"

import lottieAnimation4 from "../../lottie/question1.json"
import lottieAnimation5 from "../../lottie/question2.json"
import lottieAnimation6 from "../../lottie/question3.json"
import { useLanguage } from "../context/Languagecontext";
import { useTranslatedText } from "../../hooks/useTranslatedText";
import { convertToNativeNumerals } from "../../utils/numberUtils";
import DiceButton from "./DiceButton";
import BadWordWarning from "./Badwordwarning";
import useBadWordDetection from "../../hooks/Usebadworddetection";

const Category5 = ({ hint, uploadedImage, originalData, username, category }) => {
    const { lanText, t } = useLanguage();
    const [isRecording, setIsRecording] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [selectedAnimation, setSelectedAnimation] = useState(null); // Replace selectedGif and selectedImage
    const lottieRef = useRef(null);
    const isRecordingRef = useRef(false);
    // Audio playback states
    const [isPlaying, setIsPlaying] = useState(false);
    const [playbackTime, setPlaybackTime] = useState(0);
    const [audioDuration, setAudioDuration] = useState(0);
    const [isPaused, setIsPaused] = useState(false); // New state to track if audio is paused
    const [isRequestingMic, setIsRequestingMic] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [isUploading2, setIsUploading2] = useState(false);
    const [canStopRecording, setCanStopRecording] = useState(false);
    const [disable, setDisable] = useState(false);
    const [isCheckingConnection, setIsCheckingConnection] = useState(false);
    const [isCheckingConnection2, setIsCheckingConnection2] = useState(false);
    const [isMaskingAudio, setIsMaskingAudio] = useState(false);
    const [maskedAudioUrl, setMaskedAudioUrl] = useState(null);
    const { showSnackbar } = useSnackbar();
    const [alertModal, setAlertModal] = useState({
        show: false,
        message: '',
        title: 'Alert'
    });
    const [alertModal2, setAlertModal2] = useState({
        show: false,
        message: '',
        title: 'Alert'
    });

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isiOSSafari = isIOS && isSafari;
    const checkInternetConnection = async () => {
        // Add 2 second delay
        await new Promise(resolve => setTimeout(resolve, 200));

        // First check navigator.onLine
        if (!navigator.onLine) {
            return false;
        }

        // Double-check with a real network request
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

            clearTimeout(timeoutId);
            return true;
        } catch (error) {
            // console.log('Network check failed:', error);
            return false;
        }
    };

    if (!sessionStorage.getItem('micDeniedCount')) {
        sessionStorage.setItem('micDeniedCount', '0');
    }

    const questionTitles = ["question", "प्रश्न", "pregunta"];

    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /Android/i.test(ua);

    const isMobile = () => {
        return window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    const showAlert = (message, title = 'Alert') => {
        if (isMobile()) {
            setAlertModal({ show: true, message, title });
        } else {
            setAlertModal({ show: true, message, title });
        }
    };

    const showAlert2 = (message, title = 'Alert') => {
        if (isMobile()) {
            setAlertModal2({ show: true, message, title });
        } else {
            setAlertModal2({ show: true, message, title });
        }
    };

    const abortControllerRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const timerRef = useRef(null);
    const streamRef = useRef(null);
    const audioRef = useRef(null); // For audio playback
    const playbackTimerRef = useRef(null); // For playback progress
    const preloadedImagesRef = useRef(new Map()); // Cache for preloaded images

    const data = originalData.question
    const confessionTitle = Array.isArray(data)
        ? data.find(item => item.category === category)?.answer.confessionTitle ?? "confession"
        : "confession";
    const translatedconfessionTitle = useTranslatedText(confessionTitle, lanText);


    // Array of available GIFs
    const confessionAnimations = useMemo(() => [
        lottieAnimation1,
        lottieAnimation2,
        lottieAnimation3
    ], []);

    const questionAnimations = useMemo(() => [
        lottieAnimation4,
        lottieAnimation5,
        lottieAnimation6
    ], []);

    // Update allImages to only include static images (remove gifs):
    const allImages = useMemo(() => {
        return [microphone];
    }, []);



    // ================================== common ===================================
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [confessionEmoji, setConfessionEmoji] = useState("");

    const selectedGradient = "#8001CE"


    const confessionArray = ["https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/conemoji1.png", "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/conemoji2.png", "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/conemoji3.png"];
    const questionArray = ["https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/queemoji1.png", "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/queemoji2.png", "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/queemoji3.png"];
    const anotherArray = ["https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/conemoji1.png", "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/conemoji2.png", "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/confession/conemoji3.png"];
    const voiceArray = ["https://lol-image-bucket.s3.ap-south-1.amazonaws.com/voice1.png",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/voice2.png",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/voice3.png",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/voice4.png",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/voice5.png"];

    useEffect(() => {
        setConfessionEmoji(getRandom(anotherArray));
    }, [confessionTitle]);

    const getRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];


    const QUESTION_TITLES = ["question", "प्रश्न", "प्रश्न", "Sawal", "கேள்வி"];
    const CONFESSION_TITLES = ["confession", "कन्फेशन", "कन्फेशन", "Confession", "ஒப்புதல்"];

    const getConfessionEmoji = (title = "") => {
        const normalized = title.toLowerCase();

        if (QUESTION_TITLES.includes(normalized)) {
            return getRandom(questionArray);
        }

        if (CONFESSION_TITLES.includes(normalized)) {
            return getRandom(confessionArray);
        }

        return getRandom(anotherArray);
    };

    useEffect(() => {
        setConfessionEmoji(getConfessionEmoji(confessionTitle));
    }, [confessionTitle]);

    useEffect(() => {
        const handlePopState = () => {
            if (showSuccessModal) {
                setShowSuccessModal(false);
                const url = new URL(window.location.href);
                if (url.searchParams.has("success")) {
                    url.searchParams.delete("success");
                    window.history.replaceState({}, "", url.pathname);
                }
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [showSuccessModal]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get("success") === "1") {
            setShowSuccessModal(true);
        }
    }, []);

    useEffect(() => {
        isRecordingRef.current = isRecording;
    }, [isRecording]);


    const base64ToFile = (base64String, fileName) => {
        const arr = base64String.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], fileName, { type: mime });
    };

    const getCategoryValue = (confessionTitle = "") => {
        const normalized = confessionTitle.toLowerCase();

        return QUESTION_TITLES.includes(normalized)
            ? "UXVlc3Rpb24="
            : "Q29uZmVzc2lvbg==";
    };

    const getSubCategory = (confessionTitle = "") => {
        const normalized = confessionTitle.toLowerCase();

        return QUESTION_TITLES.includes(normalized)
            ? "Question"
            : "Confession";
    };

    const clearAfterUpload = () => {
        // Clear all recording/audio state
        setIsCompleted(false);
        setRecordingTime(0);
        setAudioBlob(null);
        setAudioChunks([]);
        setIsPlaying(false);
        setIsPaused(false);
        setPlaybackTime(0);
        setAudioDuration(0);
        setCanStopRecording(false);

        // Clear masked audio URL
        if (maskedAudioUrl && maskedAudioUrl.startsWith('blob:')) {
            URL.revokeObjectURL(maskedAudioUrl);
        }
        setMaskedAudioUrl(null);

        // Clear text content
        setUserContent('');

        // Stop lottie animation
        if (lottieRef.current) {
            const totalFrames = lottieRef.current.getDuration(true); // total frames
            const middleFrame = Math.floor(totalFrames / 2);
            lottieRef.current.goToAndStop(middleFrame, true);
        }

        // Clean up audio element
        if (audioRef.current) {
            audioRef.current.pause();
            if (audioRef.current.src && audioRef.current.src.startsWith('blob:')) {
                URL.revokeObjectURL(audioRef.current.src);
            }
            audioRef.current = null;
        }

        // Clear playback timer
        if (playbackTimerRef.current) {
            clearInterval(playbackTimerRef.current);
            playbackTimerRef.current = null;
        }
    };

    // ================================ voice game===========================================


    // Preload images function
    const preloadImages = useCallback(() => {
        return Promise.all(
            allImages.map((src) => {
                return new Promise((resolve) => {
                    if (preloadedImagesRef.current.has(src)) {
                        resolve(src);
                        return;
                    }

                    const img = new Image();
                    img.onload = () => {
                        preloadedImagesRef.current.set(src, img);
                        resolve(src);
                    };
                    img.onerror = () => {
                        console.warn(`Failed to preload image: ${src}`);
                        resolve(src);
                    };
                    img.src = src;
                });
            })
        );
    }, [allImages]); // only changes when allImages changes


    // Fixed progress percentage calculation
    const getProgressPercentage = () => {
        if (isRecording) {
            // Recording progress (0-10 seconds)
            return Math.min((recordingTime / 10) * 100, 100);
        } else if ((isPlaying || isPaused)) {
            return Math.min((playbackTime / 10) * 100, 100);
        } else if (isCompleted && !isPlaying && !isPaused) {
            // Show full progress when completed and not playing/paused
            return Math.min((recordingTime / 10) * 100, 100);
        }
        return 0;
    };

    const progressPercentage = getProgressPercentage();
    const dotRotation = -135 + (270 * progressPercentage) / 100;


    // Start recording with enhanced permission handling
    const startRecording = async () => {
        let initialPermissionState = 'prompt';

        try {
            setIsRequestingMic(true);

            // Check permission state BEFORE requesting
            if (navigator.permissions) {
                try {
                    const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
                    initialPermissionState = permissionStatus.state;
                } catch (permError) {
                    console.log('Permission query not supported, assuming prompt will show');
                }
            }

            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            setIsRequestingMic(false);
            setIsRecording(true);
            streamRef.current = stream;

            let options = { mimeType: "audio/webm" };
            if (!MediaRecorder.isTypeSupported("audio/webm")) {
                options = { mimeType: "audio/mp4" };
            }
            if (!MediaRecorder.isTypeSupported("audio/mp4")) {
                options = {};
            }

            const mediaRecorder = new MediaRecorder(stream, options);
            mediaRecorderRef.current = mediaRecorder;

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    setAudioChunks(prev => [...prev, event.data]);
                }
            };

            mediaRecorder.onstop = () => {
                setAudioChunks(current => {
                    const mimeType = mediaRecorder.mimeType || "audio/webm";
                    const blob = new Blob(current, { type: mimeType });
                    setAudioBlob(blob);
                    return current;
                });
            };

            mediaRecorder.start();

            timerRef.current = setInterval(() => {
                setRecordingTime(prev => {
                    const newTime = prev + 0.1;

                    // Enable stop button after 1 second
                    if (newTime >= 1 && !canStopRecording) {
                        setCanStopRecording(true);
                    }

                    if (newTime >= 10) {
                        stopRecording();
                        return 10;
                    }
                    return newTime;
                });
            }, 100);

        } catch (error) {
            setIsRequestingMic(false);
            setIsRecording(false);

            if (error.name === 'NotAllowedError') {
                // Check current permission state
                if (navigator.permissions) {
                    try {
                        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });

                        if (permissionStatus.state === 'denied' && initialPermissionState === 'denied') {
                            // Permission was ALREADY blocked - popup never showed
                            if (isAndroid || /Android/i.test(navigator.userAgent)) {
                                showAlert(t.whoTalkin.blockedIOS || "Microphone permission is blocked. To enable:\n1. Tap the three dots (⋮) in browser\n2. Go to Site settings\n3. Tap Microphone\n4. Select 'Allow'");
                            } else {
                                showAlert(t.whoTalkin.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                            }
                        } else {
                            // User just clicked "Block" or "Deny" on the popup that was shown
                            if (isiOSSafari) {
                                let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;

                                if (micDeniedCount > 2) {
                                    showAlert2(t.whoTalkin.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                                } else {
                                    showSnackbar(t.whoTalkin.denied || "Microphone access was denied. Please refresh the page.", "error");
                                    micDeniedCount += 1;
                                    sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());
                                    setDisable(true);
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1000);
                                }
                            } else {
                                showSnackbar(t.whoTalkin.denied || "Microphone access was denied", "error");
                                setDisable(true);
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }
                        }
                    } catch (permError) {
                        if (isiOSSafari) {
                            let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;

                            if (micDeniedCount > 2) {
                                showAlert2(t.whoTalkin.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                            } else {
                                showSnackbar(t?.whoTalkin?.denied || "Microphone access was denied. Please refresh the page.", "error");
                                micDeniedCount += 1;
                                sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());
                                setDisable(true);
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }
                        } else {
                            showSnackbar(t?.whoTalkin?.denied || "Microphone access was denied", "error");
                            setDisable(true);
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    }
                } else {
                    if (isiOSSafari) {
                        let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;

                        if (micDeniedCount > 2) {
                            showAlert2(t.whoTalkin.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                        } else {
                            showSnackbar(t?.whoTalkin?.denied || "Microphone access was denied. Please refresh the page.", "error");
                            micDeniedCount += 1;
                            sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());
                            setDisable(true);
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                    } else {
                        showSnackbar(t?.whoTalkin?.denied || "Microphone access was denied", "error");
                        setDisable(true);
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                }
            }
        }
    };


    // Stop/pause recording
    const stopRecording = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
            mediaRecorderRef.current.stop();
        }

        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }

        setIsRecording(false);
        setIsCompleted(true);
        setCanStopRecording(false); // Reset the flag
    };

    // Also update your restartRecording function to properly clean up audio:
    const restartRecording = () => {
        setIsCompleted(false);
        setRecordingTime(0);
        setAudioBlob(null);
        setAudioChunks([]);
        setIsPlaying(false);
        setIsPaused(false);
        setPlaybackTime(0);
        setAudioDuration(0);
        setCanStopRecording(false);

        // Clean up masked audio URL if it's a blob URL
        if (maskedAudioUrl && maskedAudioUrl.startsWith('blob:')) {
            URL.revokeObjectURL(maskedAudioUrl);
        }
        setMaskedAudioUrl(null);

        if (lottieRef.current) {
            lottieRef.current.stop();
        }

        if (audioRef.current) {
            audioRef.current.pause();
            if (audioRef.current.src && audioRef.current.src.startsWith('blob:')) {
                URL.revokeObjectURL(audioRef.current.src);
            }
            audioRef.current = null;
        }

        if (playbackTimerRef.current) {
            clearInterval(playbackTimerRef.current);
            playbackTimerRef.current = null;
        }
    };

    // Fixed audio playback functions
    const playAudio = async () => {
        if (!audioBlob) return;

        if (!navigator.onLine) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return null;
        }


        // If not already masked, call masking API first
        if (!maskedAudioUrl && !isMaskingAudio) {
            try {
                setIsMaskingAudio(true); // Show loader in play button
                const maskedUrl = await handleVoiceMasking();
                setIsMaskingAudio(false); // Hide loader

                if (!maskedUrl) return;

                // Now play the masked audio
                playMaskedAudio(maskedUrl);
            } catch (error) {
                console.error('Error masking audio:', error);
                setIsMaskingAudio(false); // Hide loader on error
                return;
            }
        } else if (maskedAudioUrl) {
            // Already masked, just play
            playMaskedAudio(maskedAudioUrl);
        }
    };

    // New function to play masked audio
    const playMaskedAudio = (audioUrl) => {
        if (!audioRef.current) {
            try {
                const audio = new Audio();
                audio.preload = 'metadata';
                audio.controls = false;

                audio.addEventListener('loadedmetadata', () => {
                    setAudioDuration(audio.duration);
                });

                audio.addEventListener('canplay', () => {
                    playNow();
                });

                audio.addEventListener('error', (e) => {
                    console.error('Audio error:', e);
                    setIsPlaying(false);
                    setIsPaused(false);
                });

                audio.addEventListener('ended', () => {
                    setIsPlaying(false);
                    setIsPaused(false);
                    setPlaybackTime(0);
                    if (playbackTimerRef.current) {
                        clearInterval(playbackTimerRef.current);
                        playbackTimerRef.current = null;
                    }
                });

                audioRef.current = audio;
                audio.src = audioUrl;
                audio.load();

            } catch (error) {
                console.error('Error creating audio:', error);
                setIsPlaying(false);
                setIsPaused(false);
            }
        } else {
            playNow();
        }
    };

    const resumeAudio = () => {
        if (audioRef.current) {
            // Set the current time to where it was paused
            audioRef.current.currentTime = playbackTime;
            playNow();
        }
    };
    const playNow = () => {
        if (!audioRef.current) return;

        const playPromise = audioRef.current.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                setIsPlaying(true);
                setIsPaused(false);

                if (playbackTimerRef.current) {
                    clearInterval(playbackTimerRef.current);
                }

                playbackTimerRef.current = setInterval(() => {
                    if (audioRef.current && !audioRef.current.paused && !audioRef.current.ended) {
                        setPlaybackTime(audioRef.current.currentTime);
                    }
                }, 50);

            }).catch(error => {
                console.error('Error playing audio:', error);
                setIsPlaying(false);
                setIsPaused(false);

            });
        }
    };

    const pauseAudio = () => {
        if (audioRef.current && !audioRef.current.paused) {
            audioRef.current.pause();
            setIsPlaying(false);
            setIsPaused(true);
            if (playbackTimerRef.current) {
                clearInterval(playbackTimerRef.current);
                playbackTimerRef.current = null;
            }
        }
    };

    const handleVisibilityChange = useCallback(() => {
        if (document.hidden) {
            // Stop recording if active
            if (isRecordingRef.current) {
                if (timerRef.current) {
                    clearInterval(timerRef.current);
                    timerRef.current = null;
                }
                if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
                if (streamRef.current) {
                    streamRef.current.getTracks().forEach(track => track.stop());
                    streamRef.current = null;
                }
                setIsRecording(false);
                setIsCompleted(true);
                setCanStopRecording(false);
            }

            // Pause audio if playing
            if (audioRef.current && !audioRef.current.paused) {
                audioRef.current.pause();
                setIsPlaying(false);
                setIsPaused(true);
                if (playbackTimerRef.current) {
                    clearInterval(playbackTimerRef.current);
                    playbackTimerRef.current = null;
                }
            }
        }
    }, []);

    // 5. Enhanced cleanup function
    const cleanup = () => {
        // 👇 Cancel any in-flight voice masking request
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }

        if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
        if (playbackTimerRef.current) { clearInterval(playbackTimerRef.current); playbackTimerRef.current = null; }
        if (streamRef.current) { streamRef.current.getTracks().forEach(track => track.stop()); streamRef.current = null; }
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
            mediaRecorderRef.current.stop(); mediaRecorderRef.current = null;
        }
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            if (audioRef.current.src) URL.revokeObjectURL(audioRef.current.src);
            audioRef.current = null;
        }
    };


    // 7. Add this check for Safari compatibility
    const checkSafariCompatibility = () => {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            console.log('Safari detected - using enhanced audio compatibility mode');
        }
        return isSafari;
    };

    // 8. Add this to your useEffect for initialization
    useEffect(() => {
        const initializeComponent = async () => {
            checkSafariCompatibility();

            // Select random animation based on confessionTitle
            const isQuestion = questionTitles.includes(
                confessionTitle?.toLowerCase()
            );
            const animationsArray = isQuestion ? questionAnimations : confessionAnimations;
            const randomAnimation = animationsArray[Math.floor(Math.random() * animationsArray.length)];
            setSelectedAnimation(randomAnimation);
        };

        initializeComponent();
    }, [confessionAnimations, questionAnimations, preloadImages, confessionTitle]);

    useEffect(() => {
        if (lottieRef.current) {
            if (isRecording || isPlaying) {
                lottieRef.current.play();
            } else if (!isCompleted && !isRecording && !isPlaying && recordingTime === 0) {
                // Initial state — never played yet, stay at frame 0
                lottieRef.current.goToAndStop(0, true);
            } else {
                // Has played before — pause at current position
                lottieRef.current.pause();
            }
        }
    }, [isRecording, isPlaying, isCompleted, recordingTime]);

    // Update your handlePlayPauseClick function:
    const handlePlayPauseClick = () => {
        if (isPlaying) {
            pauseAudio();
        } else if (isPaused) {
            // Resume from paused position
            resumeAudio();
        } else {
            // Start playing from beginning
            playAudio();
        }
    };

    const handleMainButtonClick = async () => {
        if (!isRecording && !isCompleted) {
            await startRecording();
        } else if (isRecording) {
            stopRecording();
        }
    };

    // Handle close button click (restart)
    const handleCloseButtonClick = () => {
        if (isRecording) {
            cleanup();
            setIsRecording(false);
            setRecordingTime(0);
            setAudioChunks([]);
        } else {
            restartRecording();
        }
    };

    // Handle tick button click (upload)
    const handleVoiceMasking = async () => {
        try {
            // Cancel any previous request
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            abortControllerRef.current = new AbortController();

            const formData = new FormData();
            const audioFile = new File([audioBlob], 'recording.webm', {
                type: audioBlob.type
            });
            formData.append('confessionVoice', audioFile);

            const response = await fetch('https://api.lolcards.link/api/newinbox/voice-masking', {
                method: 'POST',
                body: formData,
                signal: abortControllerRef.current.signal  // 👈 attach signal
            });

            if (!response.ok) throw new Error('Voice masking failed');

            const result = await response.json();
            if (result.status !== 1) throw new Error(result.message || 'Voice masking failed');

            const maskedUrl = result.data;
            const status = result.audioStatus;

            if (status === "original") {
                logEvent(analytics, "Web_Confession_Original", {
                    page_location: `${window.location.origin}/${username}/${category}`,
                    page_path: `/${username}/${category}`,
                    debug: 'true'
                });
            }

            setMaskedAudioUrl(maskedUrl);
            return maskedUrl;

        } catch (apiError) {
            if (apiError.name === 'AbortError') {
                // 👇 Silently return null — back button was pressed, no snackbar needed
                return null;
            }
            console.error('Voice masking API error:', apiError);
            showSnackbar(t?.common?.apiFail || 'Request failed. Please try again after some time!', "error");
            const originalUrl = URL.createObjectURL(audioBlob);
            setMaskedAudioUrl(originalUrl);
            return originalUrl;
        }
    };


    const handleTickButtonClick = async () => {
        try {
            setIsCheckingConnection2(true);

            const isOnline = await checkInternetConnection();
            setIsCheckingConnection2(false);

            if (!isOnline) {
                showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
                return;
            }

            // Pause audio if playing
            if (audioRef.current && !audioRef.current.paused) {
                audioRef.current.pause();
                setIsPlaying(false);
                setIsPaused(true);
                if (playbackTimerRef.current) {
                    clearInterval(playbackTimerRef.current);
                    playbackTimerRef.current = null;
                }
            }

            // If not already masked, call masking API first
            let finalMaskedUrl = maskedAudioUrl;
            if (!maskedAudioUrl) {
                setIsUploading2(true); // Start loader here
                finalMaskedUrl = await handleVoiceMasking();
                if (!finalMaskedUrl) {
                    setIsUploading2(false); // Stop loader if masking fails
                    return;
                }
            }

            // Now upload with masked audio (loader already running)
            await uploadAudioWithMaskedUrl(finalMaskedUrl);
            await axios.patch('https://api.lolcards.link/api/admin/monitoring', {
                categoryname: getCategoryValue(confessionTitle),
                id: originalData.id
            });
        } catch (err) {
            console.error('Error in handleTickButtonClick:', err);
            setIsUploading2(false); // Stop loader on error
        }
    };

    // New function to upload audio with masked URL
    const uploadAudioWithMaskedUrl = async (maskedUrl) => {
        setIsUploading2(true);
        const deviceIp = localStorage.getItem("deviceIp");

        try {
            const formData = new FormData();

            // Check if maskedUrl is a blob URL (original audio fallback)
            const isOriginalAudio = maskedUrl.startsWith('blob:');
            let fileName = 'recording.webm';
            if (audioBlob.type.includes('mp4')) {
                fileName = 'recording.mp4';
            } else if (audioBlob.type.includes('wav')) {
                fileName = 'recording.wav';
            }
            const audioFile = new File([audioBlob], fileName, { type: audioBlob.type });

            if (isOriginalAudio) {
                // If voice masking failed, send original audio file
                formData.append('ques5audio', audioFile);
            } else {
                // If voice masking succeeded, send masked URL
                formData.append('confessionVoice', maskedUrl);
            }

            formData.append('hintAudio', audioFile);
            formData.append('id', originalData?.id || '');
            formData.append("webCategory", category);
            formData.append("category", getCategoryValue(confessionTitle));
            formData.append('hint', hint || '');

            if (uploadedImage) {
                if (uploadedImage.startsWith('data:image')) {
                    formData.append('uploadedImage', base64ToFile(uploadedImage, 'hintImage.jpg'));
                } else {
                    formData.append('uploadedImage', uploadedImage);
                }
            }

            formData.append('userLocation', "allow");
            formData.append('deviceIp', deviceIp || '');
            formData.append('confessionType', "voice");
            formData.append('confessionTitle', confessionTitle || '');
            formData.append('confessionEmoji', getRandom(voiceArray));

            await axios.post('https://api.lolcards.link/api/newinbox/create', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const url = new URL(window.location.href);
            url.searchParams.set('success', '1');
            window.history.pushState({ success: true }, '', url.toString());
            setShowSuccessModal(true);
            clearAfterUpload();

        } catch (error) {
            console.error('Error uploading audio:', error);
            showSnackbar(t?.common?.apiFail || 'Request failed. Please try again after some time!', "error");
        } finally {
            setIsUploading2(false);
        }
    };

    // Cleanup on unmount
    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handleVisibilityChange);

        // 👇 Handle browser back button
        const handlePopState = () => {
            // Abort any in-progress voice masking fetch
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
                abortControllerRef.current = null;
            }

            // Reset all masking/uploading states
            setIsMaskingAudio(false);
            setIsUploading2(false);
            setIsCheckingConnection2(false);

            // Full recording reset
            restartRecording();
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handleVisibilityChange);
            window.removeEventListener('popstate', handlePopState);  // 👈 cleanup
            cleanup();
        };
    }, [handleVisibilityChange]);


    const isSmallScreen = window.innerWidth < 380 && window.innerWidth !== 360;
    const isInAppBrowser = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return /Instagram|FBAN|FBAV|Messenger|Telegram/i.test(ua);
    };


    // ========================= Confession Tab Code =========================
    // =========================================================================
    const mainContainerRef = useRef(null);
    const getInitialActiveTab = () => {
        const next = sessionStorage.getItem("que5next");
        const validNext = (next === "0" || next === "1") ? parseInt(next) : 0;
        return validNext;
    };
    const [active, setActive] = useState(getInitialActiveTab);
    const [prevActive, setPrevActive] = useState(0);
    const topRef = useRef(null);
    const [userContent, setUserContent] = useState('');
    const { hasBadWord } = useBadWordDetection(userContent);
    const [isShaking, setIsShaking] = useState(false);
    const [keyboardOpen, setKeyboardOpen] = useState(false);
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const [cardAnimationComplete, setCardAnimationComplete] = useState(false);
    const [exitType, setExitType] = useState(false);
    const textareaRef = useRef(null);
    const scrollTimeoutRef = useRef(null);
    const maxLength = 150;
    const typedChars = [...userContent].length;
    const remainingChars = maxLength - [...userContent].length;

    const triggerShake = () => {
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 600);
    };

    const items = [
        { default: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/conwhitet.svg", active: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/conblackt.svg" },
        { default: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/conwhitemic.svg", active: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/conblackmic.svg" }
    ];

    // Animation variants for slide transitions
    const slideVariants = {
        enter: (direction) => ({
            x: direction > 0 ? '100%' : '-100%',
            opacity: 0
        }),
        center: {
            x: 0,
            opacity: 1
        },
        exit: (direction) => ({
            x: direction > 0 ? '-100%' : '100%',
            opacity: 0
        })
    };

    const exitAnimation = exitType === 'true'
        ? { scale: 0, }    // slide down when close button
        : { scale: 1, };


    // Handle tab change with animation direction
    const handleTabChange = async (index) => {
        setPrevActive(active);
        setActive(index);
        setCardAnimationComplete(true);
        setExitType(true);
        sessionStorage.setItem("que5next", index.toString());
    };

    const direction = active - prevActive;


    const handleContentChange = (e) => {
        const newValue = e.target.value;

        if ([...newValue].length > maxLength) {
            triggerShake();
            return;
        }
        setUserContent(e.target.value);
    };


    const handleFocus = (e) => {
        setKeyboardOpen(true);
        // Prevent default scroll behavior
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        // Clear any pending scroll operations
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        // Scroll to top immediately to prevent keyboard push
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        // Then scroll to topRef smoothly after a brief delay
        scrollTimeoutRef.current = setTimeout(() => {
            requestAnimationFrame(() => {
                if (topRef.current) {
                    const element = topRef.current;
                    const rect = element.getBoundingClientRect();
                    const scrollTop = window.scrollY || document.documentElement.scrollTop;
                    const targetY = rect.top + scrollTop;

                    window.scrollTo({
                        top: targetY,
                        behavior: "smooth"
                    });
                }
            });
        }, 100);
    };

    const handleBlur = () => {
        setKeyboardOpen(false);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };

    const upload = async () => {
        const deviceIp = localStorage.getItem("deviceIp");
        setIsUploading(true);

        try {
            const formData = new FormData();

            formData.append('id', originalData?.id || '');
            formData.append("webCategory", category);
            formData.append("category", getCategoryValue(confessionTitle));
            formData.append('hint', hint || '');

            if (uploadedImage) {
                if (uploadedImage.startsWith('data:image')) {
                    formData.append('uploadedImage', base64ToFile(uploadedImage, 'hintImage.jpg'));
                } else {
                    formData.append('uploadedImage', uploadedImage);
                }
            }

            formData.append('userLocation', "allow");
            formData.append('deviceIp', deviceIp || '');
            formData.append('confessionType', "text");
            formData.append('confessionTitle', confessionTitle || '');
            formData.append('confessionContent', userContent.trim() || '');
            formData.append('confessionEmoji', confessionEmoji);

            await axios.post('https://api.lolcards.link/api/newinbox/create', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            const url = new URL(window.location.href);
            url.searchParams.set('success', '1');
            window.history.pushState({ success: true }, '', url.toString());
            setShowSuccessModal(true);
            clearAfterUpload();
        } catch (error) {
            console.error('Error uploading data:', error);
            showSnackbar(t?.common?.apiFail || 'Request failed. Please try again after some time!', "error");
        } finally {
            setIsUploading(false);
        }
    };

    const handleSendClick = async () => {
        if (!isUploading) {
            try {
                setIsCheckingConnection(true);

                const isOnline = await checkInternetConnection();

                setIsCheckingConnection(false);

                if (!isOnline) {
                    showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
                    return;
                }

                await upload();
                await axios.patch(
                    'https://api.lolcards.link/api/admin/monitoring',
                    { categoryname: getCategoryValue(confessionTitle), id: originalData?.id }
                );
            } catch (error) {
                console.error('Error updating monitoring:', error);
            }
        }
    };

    useEffect(() => {
        let timer;

        if (active === 0) {
            setShouldAnimate(true);

            timer = setTimeout(() => {
                setCardAnimationComplete(true);
            }, 700); // 0.5s
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [active]);

    useEffect(() => {
        const isDisabled = isUploading || isUploading2 || isCheckingConnection || isCheckingConnection2 || isMaskingAudio || isRecording || isPlaying || keyboardOpen;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isUploading, isUploading2, isCheckingConnection, isCheckingConnection2, isMaskingAudio, isRecording, isPlaying, keyboardOpen]);

    return (
        <>
            <div
                className={`GTRegular`}
                style={{ background: selectedGradient , height : "100dvh"}}
                ref={mainContainerRef}
            >
                <div className={`h-100 pt-42`}>
                    <div className={`text-center mx-auto h-100`} style={{ width: "550px", maxWidth: "90vw" }}>

                        <div className="chip-container text-center d-flex align-items-center"
                            style={{ height: '80px' }}>
                            <div className="confession-chip glass-card3">
                                <div
                                    className="confession-slider-bg"
                                    style={{ transform: `translateX(${active * 58}px)` }}
                                ></div>

                                {items.map((icon, index) => (
                                    <div
                                        key={index}
                                        className="confession-chip-item w-100"
                                        onClick={() => {
                                            if (!isCheckingConnection && !isCheckingConnection2 && !isUploading && !isUploading2 && !isMaskingAudio && !isRecording && !isPlaying) {
                                                handleTabChange(index);
                                            }
                                        }}
                                    >
                                        <img
                                            src={active === index ? icon.active : icon.default}
                                            alt="icon"
                                            className={`img-fluid fade-image ${active === index ? "active" : ""}`}
                                            width={index === 0 ? 17 : index === 1 ? 27 : 20}
                                        />

                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Content area with slide animation  */}
                        {/* overflowhidden remove */}
                        <div style={{ position: 'relative', height: active === 1 ? "82%" : "82%" }}>
                            <AnimatePresence initial={false} custom={direction} mode="wait">
                                {active === 0 && (
                                    <motion.div
                                        key="text"
                                        custom={direction}
                                        variants={slideVariants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{ duration: 0.2, ease: "easeInOut" }}
                                        className={`text-center d-flex flex-column justify-content-start h-100`}
                                    >
                                        <div className="text-center py-4" style={{ maxWidth: "90vw", opacity: cardAnimationComplete ? "1" : "0", transition: "opacity 0.2s ease" }}>
                                            <p
                                                className="lh-sm mx-auto px-3 m-0 text-white"
                                                style={{ fontSize: "18px" }}
                                            >
                                                {
                                                    questionTitles.includes(confessionTitle?.toLowerCase())
                                                        ? t.confession.textTitle
                                                        : t.confession.textTitle1
                                                }
                                            </p>
                                        </div>

                                        <div ref={topRef} className='d-flex flex-column align-items-center justify-content-center mx-auto'
                                            style={{
                                                // marginTop: keyboardOpen && isIOS ? "15px" : "15px",
                                                marginBottom: keyboardOpen && isAndroid ? "0px" : "0px",
                                                paddingTop: isSmallScreen ? "40px" : "40px",
                                                transition: "margin 0.3s ease",
                                                width: "95%"
                                            }}>
                                            <motion.div
                                                className={`w-100 rounded-19 position-relative glass-card mt-2 ${isShaking ? 'shake-animation' : ''}`}
                                                style={{ height: isSmallScreen ? "215px" : "230px" }}
                                                // style={{
                                                //     background: "linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.3) 40%, rgba(255,255,255,0.1) 100%)",
                                                //     backdropFilter: "blur(12px)",
                                                //     WebkitBackdropFilter: "blur(12px)",
                                                //     boxShadow: `
                                                //                     0px 5px 20px rgba(0,0,0,0.1),
                                                //                     inset 0 2px 5px rgba(255,255,255,0.2),
                                                //                     inset 0 -3px 10px rgba(255,255,255,0.3)
                                                //                 `
                                                // }}
                                                initial={exitAnimation}
                                                animate={{ scale: shouldAnimate ? 1 : 0 }}
                                                transition={{
                                                    type: "spring",
                                                    duration: 1,
                                                    delay: 0.2
                                                }}
                                            >
                                                <div className='d-flex align-items-center justify-content-center rounded-19-top pt-4 Bugs'
                                                    style={{ height: isSmallScreen ? "75px" : "85px", background: "white", fontSize: "24px" }}>
                                                    {(translatedconfessionTitle || 'Confession').charAt(0).toUpperCase() +
                                                        (translatedconfessionTitle || 'Confession').slice(1)}

                                                </div>

                                                <div
                                                    className='p-3 d-flex align-items-center justify-content-center text-left'
                                                    style={{
                                                        height: isSmallScreen ? "130px" : "130px",
                                                        fontSize: "19px",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "break-word",
                                                        whiteSpace: "normal",
                                                    }}
                                                >
                                                    <textarea
                                                        ref={textareaRef}
                                                        value={userContent}
                                                        onChange={handleContentChange}
                                                        onFocus={handleFocus}
                                                        onBlur={handleBlur}
                                                        disabled={isUploading || isCheckingConnection}
                                                        placeholder={
                                                            (t?.confession?.typeComment || "Type your") +
                                                            " " +
                                                            (translatedconfessionTitle || "Confession").toLowerCase()
                                                        }

                                                        // maxLength={150}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                textareaRef.current?.blur();
                                                            }
                                                        }}
                                                        enterKeyHint="done"
                                                        className="w-100 h-100 border-0 custom-placeholder-5 GTRegular text-white bg-transparent"
                                                        style={{
                                                            resize: "none",
                                                            outline: "none",
                                                            fontSize: "17px",
                                                            fontWeight: "500",
                                                            height: isSmallScreen ? "90px" : "100px",
                                                            textAlign: userContent ? "start" : "start",
                                                            padding: userContent.length > 0 ? "0px" : "0px",
                                                        }}
                                                    />


                                                    <DiceButton
                                                        category={category}
                                                        subCategory={getSubCategory(confessionTitle)}
                                                        onContentFetched={(text) => setUserContent(text)}
                                                        disabled={isUploading || isCheckingConnection}
                                                    />
                                                </div>

                                                <div
                                                    style={{
                                                        width: isSmallScreen ? "60px" : "63px",
                                                        height: isSmallScreen ? "60px" : "63px",
                                                        borderRadius: "50%",
                                                        background: "white",
                                                        position: "absolute",
                                                        top: "-35px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            border: "1.5px solid black",
                                                            width: "100%",
                                                            height: "100%",
                                                            borderRadius: "50%",
                                                            background: "white",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            overflow: "hidden"
                                                        }}
                                                    >
                                                        <img
                                                            src={confessionEmoji}
                                                            alt="avatar"
                                                            style={{
                                                                width: "75%",
                                                                height: "75%",
                                                                objectFit: "contain"
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </motion.div>
                                            <p className={`text-end pe-3 w-100 text-white my-1 GTMedium ${remainingChars <= 0 ? 'limit-reached' : ''}`} style={{ opacity: cardAnimationComplete ? "1" : "0", transition: "opacity 0.2s ease", }}>
                                                {convertToNativeNumerals(typedChars, lanText)}/{convertToNativeNumerals(maxLength, lanText)}
                                            </p>
                                            <BadWordWarning
                                                visible={hasBadWord}
                                                message={
                                                    t?.common?.badWordWarning ||
                                                    "Avoid using offensive language"
                                                }
                                            />
                                        </div>

                                        <div className='w-100' style={{ marginTop: isSmallScreen ? "25px" : "25px", opacity: cardAnimationComplete ? "1" : "0", transition: "opacity 0.2s ease" }}>
                                            <Button
                                                className="rounded-pill border-0 mx-auto mb-2 text-white"
                                                disabled={!userContent.trim()}
                                                style={{
                                                    padding: "12px 1px",
                                                    height: "52px",
                                                    width: "75%",
                                                    pointerEvents: (!isUploading && isCheckingConnection && !userContent.trim()) ? 'none' : 'auto',
                                                    cursor: (!isUploading && isCheckingConnection && !userContent.trim()) ? 'not-allowed' : 'pointer',
                                                    background: "black",
                                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                                }}
                                                onClick={handleSendClick}
                                            >
                                                {isUploading || isCheckingConnection ? (
                                                    <>
                                                        <div className="custom-spinner" style={{ borderTopColor: "#fff" }} />
                                                    </>
                                                ) : (
                                                    <span className="GTMedium"
                                                        style={{
                                                            fontSize: "clamp(21px, 4.5vw, 27px)",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {t?.common?.send || "Send"}
                                                    </span>
                                                )}
                                            </Button>
                                        </div>


                                    </motion.div>
                                )}

                                {active === 1 && (
                                    <motion.div
                                        key="upload"
                                        custom={direction}
                                        variants={slideVariants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{ duration: 0.2, ease: "easeInOut" }}
                                        className="text-center d-flex flex-column justify-content-between h-100"
                                    >
                                        {/* Title Section */}
                                        <div className="text-center pb-2 pt-2 mx-auto">
                                            <p className={`lh-sm mx-auto px-3 m-0 text-white`} style={{ fontSize: "18px" }}>
                                                {
                                                    questionTitles.includes(confessionTitle?.toLowerCase())
                                                        ? t.confession.title
                                                        : t.confession.title1
                                                }
                                            </p>
                                        </div>

                                        {/* Circular Progress Section */}
                                        <div className="d-flex justify-content-center align-items-center flex-grow-1">
                                            <div className="d-flex justify-content-center align-items-center">
                                                {/* Circular Progress Bar Container */}
                                                <div
                                                    className="position-relative"
                                                    style={{
                                                        width: 285,
                                                        height: 285,
                                                    }}
                                                >
                                                    {/* Circular Progress Bar */}
                                                    <CircularProgressbarWithChildren
                                                        value={progressPercentage}
                                                        circleRatio={0.75}
                                                        styles={buildStyles({
                                                            rotation: 0.625,
                                                            strokeLinecap: "round",
                                                            pathColor: "#ffffff",
                                                            trailColor: "rgba(255, 255, 255, 0.66)",
                                                            pathTransition: (isRecording || isPlaying) ? "stroke-dashoffset 0.05s linear" : "stroke-dashoffset 0.3s ease",
                                                        })}
                                                        strokeWidth={3}
                                                    >
                                                        {/* Inner colored circle with gif */}
                                                        <div
                                                            className="rounded-circle d-flex glass-card2 overflow-hidden justify-content-center align-items-center"
                                                            style={{
                                                                width: "253px",
                                                                height: "253px",
                                                                // background: "linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0.2) 100%)",
                                                                // backdropFilter: "blur(12px)",
                                                                // WebkitBackdropFilter: "blur(12px)",
                                                                // boxShadow: `
                                                                //     inset 0 2px 5px rgba(255,255,255,0.2),
                                                                //     inset 0 -3px 10px rgba(255,255,255,0.3)
                                                                // `
                                                            }}
                                                        >
                                                            {selectedAnimation && (
                                                                <Lottie
                                                                    lottieRef={lottieRef}
                                                                    animationData={selectedAnimation}
                                                                    loop={true}
                                                                    autoplay={false}
                                                                    onDOMLoaded={() => {
                                                                        if (lottieRef.current) {
                                                                            const totalFrames = lottieRef.current.getDuration(true); // total frames
                                                                            const middleFrame = Math.floor(totalFrames / 2);
                                                                            lottieRef.current.goToAndStop(middleFrame, true); // middle frame
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: "180px",
                                                                        height: "180px",
                                                                    }}
                                                                />
                                                            )}
                                                            {/* Loading indicator while animation loads */}
                                                            {!selectedAnimation && (
                                                                <div
                                                                    className="position-absolute d-flex justify-content-center align-items-center"
                                                                    style={{
                                                                        width: "200px",
                                                                        height: "200px",
                                                                        borderRadius: "50%"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="spinner-border"
                                                                        style={{ width: "2rem", height: "2rem", color: "#BD74E0" }}
                                                                        role="status"
                                                                    >
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </CircularProgressbarWithChildren>

                                                    {/* Fixed Moving Dot/Pointer */}
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            width: "12px",
                                                            height: "12px",
                                                            backgroundColor: "#fff",
                                                            borderRadius: "50%",
                                                            transform: `translate(-50%, -50%) rotate(${dotRotation}deg) translateY(-138px)`,
                                                            transformOrigin: "center",
                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                                            transition: (isRecording || isPlaying) ? "transform 0.05s linear" : "transform 0.3s ease",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Bottom Control Section */}
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div
                                                className='rounded-5 position-relative'
                                                style={{
                                                    minHeight: isSmallScreen ? "100px" : "100px",
                                                    width: "100%",
                                                    maxWidth: "500px",
                                                    background: "linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%)",
                                                    backdropFilter: "blur(12px)",
                                                    WebkitBackdropFilter: "blur(12px)",
                                                    boxShadow: "0px 10px 20px rgba(0,0,0,0.07), inset 0 1px 1px rgba(255,255,255,0.2), inset 0 -1px 1px rgba(255,255,255,0.2)"
                                                }}
                                            >
                                                <div
                                                    className='p-3 fw-semibold h-50 text-start d-flex flex-column align-items-center justify-content-center'
                                                >
                                                    {/* Three Button Layout */}
                                                    <div className="d-flex align-items-center justify-content-evenly gap-4 w-100">
                                                        {/* Left Button Slot (Close) */}
                                                        <div style={{ width: "55px", height: "55px" }}>
                                                            <button
                                                                className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: "55px",
                                                                    height: "55px",
                                                                    background: `
                                                                        radial-gradient(
                                                                        circle at center,
                                                                      rgba(255,255,255,0.40) 0%,
                                                                      rgba(255,255,255,0.30) 40%,
                                                                      rgba(255,255,255,0.22) 70%,
                                                                      rgba(255,255,255,0.03) 100%
                                                                        )
                                                                    `,
                                                                    backdropFilter: "blur(10px)",
                                                                    WebkitBackdropFilter: "blur(10px)",
                                                                    border: "1px solid rgba(255,255,255,0.35)",
                                                                    transition: "all 0.3s ease",
                                                                    opacity: isCompleted ? 1 : 0.3,
                                                                    pointerEvents: isCompleted ? "auto" : "none"
                                                                }}
                                                                onClick={handleCloseButtonClick}
                                                                disabled={isUploading2 || isCheckingConnection2 || isMaskingAudio}
                                                            >
                                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g clip-path="url(#clip0_13163_5302)">
                                                                        <path d="M11.248 1.40039H11.2549C16.6867 1.40039 21.1093 5.82309 21.1094 11.2549C21.1094 16.6868 16.6868 21.1094 11.2549 21.1094C5.82304 21.1093 1.40039 16.6867 1.40039 11.2549C1.40045 8.3734 2.64498 5.77642 4.625 3.97168L5.5791 3.10156H2.24414C2.1911 3.10231 2.13809 3.09301 2.08887 3.07324C2.03962 3.05345 1.99482 3.02359 1.95703 2.98633C1.91928 2.94909 1.88961 2.90439 1.86914 2.85547C1.84871 2.80657 1.83789 2.75417 1.83789 2.70117C1.83791 2.64815 1.84868 2.5958 1.86914 2.54688C1.88962 2.49792 1.91924 2.45328 1.95703 2.41602C1.99477 2.37881 2.03971 2.34986 2.08887 2.33008C2.13811 2.31029 2.19108 2.30003 2.24414 2.30078H6.70312V6.75977C6.70387 6.81275 6.69453 6.86586 6.6748 6.91504C6.65502 6.96427 6.62514 7.00909 6.58789 7.04688C6.55063 7.08466 6.50599 7.11526 6.45703 7.13574C6.4082 7.1561 6.35564 7.16602 6.30273 7.16602C6.24981 7.16601 6.19728 7.15612 6.14844 7.13574C6.09948 7.11526 6.05484 7.08466 6.01758 7.04688C5.98037 7.00912 5.95142 6.96422 5.93164 6.91504C5.92172 6.89036 5.91401 6.86489 5.90918 6.83887L5.90234 6.75977V3.8623L5.06055 4.65234C3.302 6.3021 2.20123 8.64584 2.20117 11.2549C2.20117 16.2658 6.24398 20.3085 11.2549 20.3086C16.2658 20.3086 20.3086 16.2658 20.3086 11.2549C20.3085 6.24402 16.2658 2.20117 11.2549 2.20117H11.248C11.195 2.20192 11.142 2.19264 11.0928 2.17285C11.0435 2.15306 10.9987 2.12319 10.9609 2.08594C10.9232 2.04871 10.8935 2.00398 10.873 1.95508C10.8526 1.90618 10.8418 1.85377 10.8418 1.80078C10.8418 1.74777 10.8526 1.6954 10.873 1.64648C10.8935 1.59754 10.9232 1.55288 10.9609 1.51562C10.9987 1.47844 11.0436 1.44947 11.0928 1.42969C11.142 1.4099 11.195 1.39964 11.248 1.40039Z" fill="black" stroke="white" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_13163_5302">
                                                                            <rect width="22.51" height="22.51" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </button>
                                                        </div>

                                                        {isCompleted ? (
                                                            <div
                                                                className="rounded-circle d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: "65px",
                                                                    height: "65px",
                                                                    backgroundColor: "white",
                                                                    border: "none",
                                                                    boxShadow: "0 0px 5.15px 0px rgba(0,0,0,0.3)",
                                                                    transform: isPlaying ? "scale(1.05)" : "scale(1)",
                                                                    animation: isPlaying ? "pulse 1.5s infinite" : "none"
                                                                }}
                                                            >
                                                                <button
                                                                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                                    style={{
                                                                        width: "55px",
                                                                        height: "55px",
                                                                        background: selectedGradient,
                                                                        border: "none",
                                                                        color: "white",
                                                                    }}
                                                                    onClick={handlePlayPauseClick}
                                                                    disabled={isUploading2 || isCheckingConnection2 || isMaskingAudio}
                                                                >
                                                                    {isMaskingAudio ? (
                                                                        <div
                                                                            className="spinner-border spinner-border-sm"
                                                                            style={{
                                                                                width: "20px",
                                                                                height: "20px",
                                                                                color: "white"
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <FontAwesomeIcon
                                                                            icon={isPlaying ? faPause : faPlay}
                                                                            style={{ fontSize: "25px" }}
                                                                        />
                                                                    )}
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="rounded-circle d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: "65px",
                                                                    height: "65px",
                                                                    backgroundColor: "white",
                                                                    border: "none",
                                                                    transition: "all 0.3s ease",
                                                                    boxShadow: "0 0px 5.15px 0px rgba(0,0,0,0.2)",
                                                                    transform: isRecording ? "scale(1.05)" : "scale(1)",
                                                                    animation: isRecording ? "pulse 1.5s infinite" : "none"
                                                                }}
                                                            >
                                                                <button
                                                                    className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                                    style={{
                                                                        width: "55px",
                                                                        height: "55px",
                                                                        background: selectedGradient,
                                                                        border: "none",
                                                                        color: "white",
                                                                        opacity: (isRecording && !canStopRecording) || disable ? 1 : 1,
                                                                        cursor: (isRecording && !canStopRecording) || disable ? 'not-allowed' : 'pointer'
                                                                    }}
                                                                    onClick={handleMainButtonClick}
                                                                    disabled={isUploading2 || isRequestingMic || (isRecording && !canStopRecording) || disable}
                                                                >
                                                                    {isRequestingMic ? (
                                                                        <div
                                                                            className="spinner-border spinner-border-sm"
                                                                            style={{
                                                                                width: "20px",
                                                                                height: "20px",
                                                                                color: "white"
                                                                            }}
                                                                        />
                                                                    ) : isRecording ? (
                                                                        <FontAwesomeIcon icon={faStop} style={{ fontSize: "25PX" }} />
                                                                    ) : (
                                                                        <img src={microphone} alt="microphone" className="img-fluid" />
                                                                    )}
                                                                </button>
                                                            </div>
                                                        )}

                                                        {/* Right Button Slot (Tick) */}
                                                        <button
                                                            className="btn rounded-circle d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: "55px",
                                                                height: "55px",
                                                                background: `
                                                                        radial-gradient(
                                                                        circle at center,
                                                                      rgba(255,255,255,0.40) 0%,
                                                                      rgba(255,255,255,0.30) 40%,
                                                                      rgba(255,255,255,0.22) 70%,
                                                                      rgba(255,255,255,0.03) 100%
                                                                        )
                                                                    `,
                                                                backdropFilter: "blur(10px)",
                                                                WebkitBackdropFilter: "blur(10px)",
                                                                border: "1px solid rgba(255,255,255,0.35)",
                                                                transition: "all 0.3s ease",
                                                                opacity: isCompleted ? 1 : 0.3,
                                                                pointerEvents: isCompleted ? "auto" : "none"
                                                            }}
                                                            onClick={handleTickButtonClick}
                                                            disabled={isUploading2 || isCheckingConnection2 || isMaskingAudio}
                                                        >
                                                            {isUploading2 || isCheckingConnection2 ? (
                                                                <div
                                                                    className="spinner-border spinner-border-sm"
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        color: "#7D01C9"
                                                                    }}
                                                                />
                                                            ) : (
                                                                <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M16.9917 0.957031L5.96721 11.6475L0.956055 6.78818" stroke="white" stroke-width="1.91205" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>


                    </div>
                </div>

                {/* Alert Modal for Android */}
                {alertModal.show && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{
                            zIndex: 9999,
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            backdropFilter: 'blur(8px)'
                        }}
                        onClick={() => setAlertModal({ show: false })}
                    >
                        <div
                            className="popup-bg rounded-4 p-3 m-3"
                            style={{
                                maxWidth: '420px',
                                width: '90%',
                                boxShadow: '0 20px 55px rgba(0, 0, 0, 0.3)',
                                maxHeight: '90vh',
                                overflowY: 'auto'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Content */}
                            <div
                                className="text-center rounded-4 p-2 mx-auto"
                                style={{
                                    maxWidth: "360px",
                                }}
                            >
                                {/* Icon */}
                                <div
                                    className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        background: "#FFECEC",
                                        fontSize: "22px"
                                    }}
                                >
                                    🎤
                                </div>

                                {/* Title */}
                                <p className="mb-2 fw-semibold popup-main-color" style={{ fontSize: "18px" }}>
                                    {t.whoTalkin.micPermissionTitle}
                                </p>

                                {/* Description */}
                                <p className="mb-3" style={{ fontSize: "13px", lineHeight: "1.3", color: "#A7A7A7" }}>
                                    {t.whoTalkin.micPermissionDesc}
                                </p>

                                {/* Steps */}
                                <div
                                    className="text-start popup-center-bg d-flex flex-column justify-content-around align-items-center popup-border-dashed"
                                    style={{
                                        fontSize: "16px",
                                        lineHeight: "1.7",
                                        borderRadius: "12px",
                                        padding: "12px 12px 13px 12px",
                                    }}
                                >
                                    <h6 className="GTBold text-center popup-main-color">{t.steps} </h6>
                                    <ol className="m-0 my-4 popup-main-color">
                                        <li className="mb-2" >{t.whoTalkin.step1.text} <b>{t.whoTalkin.step1.bold}</b> {t.whoTalkin.step1.text2}</li>
                                        <li className="mb-2" >{t.whoTalkin.step2.text} <b>{t.whoTalkin.step2.bold}</b> {t.whoTalkin.step2.text2}</li>
                                        <li className="mb-2" >{t.whoTalkin.step3.text} <b>{t.whoTalkin.step3.bold}</b> {t.whoTalkin.step3.text2}</li>
                                        <li className="" >{t.whoTalkin.step4.text} <b>{t.whoTalkin.step4.bold}</b> {t.whoTalkin.step4.text2}</li>
                                    </ol>
                                </div>
                            </div>

                            {/* Button */}
                            <div className="text-center mt-3">
                                <button
                                    className="btn fw-semibold"
                                    style={{
                                        width: "90%",
                                        backgroundColor: '#BD74E0',
                                        color: 'white',
                                        borderRadius: '10px',
                                        fontSize: '16px',
                                        padding: '10px'
                                    }}
                                    onClick={() => setAlertModal({ show: false })}
                                >
                                    {t.whoTalkin.close}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Alert Modal 2 for iOS */}
                {alertModal2.show && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{
                            zIndex: 9999,
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            backdropFilter: 'blur(8px)'
                        }}
                        onClick={() => setAlertModal2({ show: false })}
                    >
                        <div
                            className="popup-bg rounded-4 p-3 m-3"
                            style={{
                                maxWidth: '420px',
                                width: '90%',
                                boxShadow: '0 20px 55px rgba(0, 0, 0, 0.3)',
                                maxHeight: '90vh',
                                overflowY: 'auto'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Content */}
                            <div
                                className="text-center rounded-4 p-2 mx-auto"
                                style={{
                                    maxWidth: "360px",
                                }}
                            >
                                {/* Icon */}
                                <div
                                    className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        background: "#FFECEC",
                                        fontSize: "22px"
                                    }}
                                >
                                    🎤
                                </div>

                                {/* Title */}
                                <p className="mb-2 fw-semibold popup-main-color" style={{ fontSize: "18px" }}>
                                    {t.whoTalkin.micPermissionTitle}
                                </p>

                                {/* Description */}
                                <p className="mb-3" style={{ fontSize: "13px", lineHeight: "1.3", color: "#A7A7A7" }}>
                                    {t.whoTalkin.micPermissionDesc}
                                </p>

                                {/* Steps */}
                                <div
                                    className="text-start popup-center-bg d-flex flex-column justify-content-around align-items-center popup-border-dashed"
                                    style={{
                                        fontSize: "16px",
                                        lineHeight: "1.7",
                                        borderRadius: "12px",
                                        padding: "12px 12px 13px 12px",
                                    }}
                                >
                                    <h6 className="GTBold text-center popup-main-color">{t.whoTalkin.steps} </h6>
                                    <ol className="m-0 my-4 popup-main-color">
                                        <li className="mb-2 popup-main-color ios-item">
                                            <span className="pe-2">{t.whoTalkin.ios1.text}</span>
                                            (<b className="icon ios-icon-1"></b>)
                                            <b className="px-2">{t.whoTalkin.ios1.bold}</b>
                                            ( <b className="icon ios-icon-2 mx-1"></b> )
                                            <span className="ps-2">{t.whoTalkin.ios1.text2}</span>
                                        </li>
                                        <li className="mb-2 popup-main-color">{t.whoTalkin.ios2.text} <b>{t.whoTalkin.ios2.bold}</b> {t.whoTalkin.ios2.text2}</li>
                                        <li className="mb-2 popup-main-color">{t.whoTalkin.ios3.text} <b>{t.whoTalkin.ios3.bold}</b> {t.whoTalkin.ios3.text2}</li>
                                        <li className="popup-main-color">{t.whoTalkin.ios4.text} <b>{t.whoTalkin.ios4.bold}</b> {t.whoTalkin.ios4.text2}</li>
                                    </ol>
                                </div>
                            </div>

                            {/* Button */}
                            <div className="text-center mt-3">
                                <button
                                    className="btn fw-semibold"
                                    style={{
                                        width: "90%",
                                        backgroundColor: '#BD74E0',
                                        color: 'white',
                                        borderRadius: '10px',
                                        fontSize: '16px',
                                        padding: '10px'
                                    }}
                                    onClick={() => setAlertModal2({ show: false })}
                                >
                                    {t.whoTalkin.close}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <CompletePopup
                    showSuccessModal={showSuccessModal}
                    toggle={() => setShowSuccessModal(false)}
                    data={originalData}
                    username={username}
                    category={category}
                    t={t}
                />

                <RotatePhonePopup
                    excludeWhen={[keyboardOpen]}
                />



                {/* CSS for animations */}
                <style jsx>{`
                @keyframes pulse {
                    0% {
                        transform: scale(1.1);
                    }
                    70% {
                        transform: scale(1.15);
                    }
                    100% {
                        transform: scale(1.1);
                    }
                }
                
                .spinner-border {
                    animation: spinner-border 0.75s linear infinite;
                }
                
                @keyframes spinner-border {
                    to {
                        transform: rotate(360deg);
                    }
                }
            `}</style>

            </div >
        </>
    );
};

export default Category5;